/**
 * Tiles.js — a labelled headline figure
 * =====================================
 * The deal page's Summary and a strategy's figures read as a row of tiles:
 * the label, the figure in the body font with tabular digits (usability review
 * item 6: no typewriter font), and one line under it saying what the figure is
 * or why it is not one. A figure the page cannot stand behind is struck
 * through with the reason, never printed plain.
 */
import React from "react";
import { InfoTip } from "../../components/PageTools";
import theme from "../../components/theme";

export function Tile({ label, value, tone, note, provisional, info, wrap }) {
  const color =
    provisional ? theme.textMuted : tone === "negative" ? theme.danger : tone === "positive" ? theme.success : theme.text;
  return (
    <div className="dr-tile">
      <div className="dr-tile-label">
        {label}
        {info && <InfoTip>{info}</InfoTip>}
      </div>
      <div
        className={`dr-tile-value${wrap ? " dr-tile-wrap" : ""}`}
        style={{ color, textDecoration: provisional ? "line-through" : "none" }}
      >
        {value}
      </div>
      {note && <div className="dr-tile-note">{note}</div>}
    </div>
  );
}

export const toneOfValue = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n) || n === 0) return undefined;
  return n > 0 ? "positive" : "negative";
};
